module.exports = __webpack_public_path__ + "img/fastDeliveryIcon.6f7e56ec.png";